import { TranslationsContext, useIsMobileHook } from '@telia-common-components/shared';
import * as React from 'react';
import { Carousel, CarouselItem, Container, EqualHeightProvider, Separator, Skeleton, SkeletonItem } from 'telia-front-react';
import InternetOfferCard from '../card/InternetOfferCard';
import { useInternetCalculator } from '../InternetCalculatorProvider';
import { ChangeSegmentNotice } from '../notice/ChangeSegmentNotice';
import { CUSTOMER_TYPE_BUSINESS, CUSTOMER_TYPE_PRIVATE, getSegment } from '../util/InternetCalculatorUtil';
import { useInternetEditOffers } from './InternetEditProvider';
import { selectedUseCasesContainSmallDevices } from '../suggest/InternetSuggestSpeedUtil';
const InternetEditCarousel = () => {
    const { internetOfferCards } = useInternetEditOffers();
    const { suggestSpeedState, auth, isSecureNet } = useInternetCalculator();
    const { translate } = React.useContext(TranslationsContext);
    const { isMobile } = useIsMobileHook();
    const calculatedSuggestion = suggestSpeedState.suggestedOffer;
    const recommendedInternetIndex = !!calculatedSuggestion && (internetOfferCards === null || internetOfferCards === void 0 ? void 0 : internetOfferCards.indexOf(internetOfferCards.find((e) => e.productOfferingCode === calculatedSuggestion)));
    const shouldShowSkeleton = !internetOfferCards.length;
    const segment = getSegment(auth);
    const internetOffers = internetOfferCards.sort((a, b) => Number(b.downloadSpeed) - Number(a.downloadSpeed));
    const renderOffers = () => {
        return (selectedUseCasesContainSmallDevices(suggestSpeedState.selectedUseCases)
            ? internetOffers
            : internetOffers.filter((offer) => !offer.properties.includes('HIDDEN_SECURE_NET_OFFER'))).map((offer) => (React.createElement(CarouselItem, { key: `internet-offer-${offer.id}` },
            React.createElement(InternetOfferCard, { offer: offer, suggestedInternet: suggestSpeedState.suggestedOffer, isRecommended: offer.productOfferingCode === suggestSpeedState.suggestedOffer }))));
    };
    return (React.createElement("div", { id: "internet-offers" },
        ((segment === CUSTOMER_TYPE_PRIVATE && isSecureNet) || (!isSecureNet && segment === CUSTOMER_TYPE_BUSINESS)) && (React.createElement(Container, null,
            React.createElement(Separator, { spacing: "xsmall", color: "invisible" }),
            React.createElement(ChangeSegmentNotice, null))),
        React.createElement(EqualHeightProvider, { groups: ['internet-speed', 'card-text', 'card-footer', 'price', 'speed-indicator'], offSet: 10 },
            React.createElement(Carousel, { nextArrowText: translate('carousel.next'), prevArrowText: translate('carousel.previous'), hasContainer: true, arrows: !isMobile, align: "left", activeItemIndex: calculatedSuggestion ? recommendedInternetIndex : undefined, breakPoint: null, slidesToShow: 1, responsive: [
                    {
                        breakPoint: 'sm',
                        props: { slidesToShow: 2 },
                    },
                    {
                        breakPoint: 'md',
                        props: { slidesToShow: 3 },
                    },
                    {
                        breakPoint: 'lg',
                        props: { slidesToShow: 4 },
                    },
                ] }, shouldShowSkeleton ? renderSkeletonItems(translate) : renderOffers()),
            React.createElement(Separator, { spacing: "xsmall", color: "invisible" }))));
};
const renderSkeletonItems = (translate) => {
    return [...Array(4).keys()].map((key) => (React.createElement(CarouselItem, { key: key },
        React.createElement(Skeleton, { key: key, label: translate('skeleton.loading') },
            React.createElement(SkeletonItem, { height: '566px' })))));
};
export default InternetEditCarousel;
